import {connect} from 'react-redux';
import CommunicationForm from './CommunicationForm.jsx';
import {
  handleSave,
  handleCancel
} from './actions';

const mapStateToProps = state => ({
  readOnly: state.tournament.base.tournamentInfo.readOnly
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: data => dispatch(handleSave(data)),
  onCancel: () => dispatch(handleCancel())
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationForm);



// WEBPACK FOOTER //
// ./src/features/tournament/communications/CommunicationFormContainer.jsx